import { isCommaDecimalLang } from 'constants/countryCodes';
import { getLocaleLang, currencyFormatter } from 'util/locale';

/** 
 * For a given string, return original string without boundary double quotes [if they are present].
 * @param {String} str "example"
 * @return {String}     example
 */
export const removeBoundaryQuotes = (str) => str.replace(/^"|"$/g, '');

export const convertPlantingPlanParams = ({validationResult, value, currency}) => {
  let display = value;
  let displayValue = display && currency
    ? currencyFormatter(display, currency)
    : '';
  if(display && display.replace && isCommaDecimalLang(getLocaleLang())) {
    if(validationResult
          && validationResult.isInvalid) {
      display = display.replace('.', ',').replace('_','.');
      displayValue = display;
    } else {
      display = display.replace('.',',').replace('_','.');
    }
  }
  return {
    display,
    displayValue
  };
};

export const convertPlantingPlanParamsToUpdate = (value) => (
  value && isCommaDecimalLang(getLocaleLang()) ? value.replace('.', '_').replace(',','.') : value);